// Where a cardholder goes (CustomerWeb Login.cshtml.cs RedirectAfterSignIn, CardAccount.OnboardingPageUrl).
import { type SessionUser } from '@qor/web-shared';

const STILL_ONBOARDING = new Set(['PendingOnboarding', 'PendingApproval']);

/** The onboarding page of a processor (ZumRails' hosted form for anything else). */
export function onboardingPath(provider: string): string {
  switch (provider) {
    case 'Mdp':
      return '/onboarding/mdp';
    case 'InterCash':
      return '/onboarding/intercash';
    case 'Gsc':
      return '/onboarding/gsc';
    case 'Central Payments':
      return '/onboarding/central-payments';
    default:
      return '/onboarding/zumrails';
  }
}

/** After sign-in: onboarding until a card exists (no provider reference, or still pending), else the account. */
export function landingPath(user: Pick<SessionUser, 'provider' | 'providerUserReference' | 'cardStatus'>): string {
  if (!['ZumRails', 'Mdp', 'InterCash', 'Central Payments'].includes(user.provider)) return '/card';
  if (!user.providerUserReference || STILL_ONBOARDING.has(user.cardStatus ?? '')) return onboardingPath(user.provider);
  return '/card';
}

/** ZumRailsOnboarding: the status line for the cardholder's card status. */
export function zumRailsStatus(status: string | null): { label: string; action: string } {
  switch (status) {
    case 'PendingApproval':
      return { label: 'Pending Approval', action: 'Wait for program approval' };
    case 'PendingOnboarding':
    case 'New':
      return { label: 'Onboarding Required', action: 'Complete cardholder onboarding' };
    case 'Suspended':
      return { label: 'Suspended', action: 'Contact program support' };
    case 'Closed':
      return { label: 'Closed', action: 'Contact program support' };
    case null:
    default:
      return { label: 'Setup Required', action: 'Complete setup' };
  }
}
